export const WELL_COLUMNS = [
  {
    header: "Объект",
    field: "facilityName",
    sortable: true,
    visible: true,
    dataType: { type: "Link" },
    link: (row, vm) => vm.onClickFacilityLink(row),
    filterData: {
      options: "facilityNames",
      type: "MultiSelect",
      mode: "in",
      "max-width": "80px",
      attrList: { filter: true, appendTo: "body", },
    },
  },
  {
    header: "№",
    field: "flangeNumber",
    sortable: true,
    visible: true,
    bodyStyle: "text-align: right;",
    filterData: {
      type: "InputText",
      "max-width": "60px",
      attrList: { type: "number", step: "1" },
    },
  },
  {
    header: "Скважина",
    field: "wellName",
    sortable: true,
    visible: true,
    dataType: { type: "Link" },
    link: (row, vm) => vm.onClickWellLink(row),
    filterData: {
      options: "wellNames",
      type: "MultiSelect",
      attrList: { filter: true, appendTo: "body", },
      mode: "in",
      "max-width": "80px",
    },
  },
  {
    header: "Тек знач",
    field: "outputValue",
    visible: false,
    sortable: true,
    bodyStyle: "text-align: right;",
  },
  {
    header: "Прош сут",
    field: "accumValueLastDay",
    visible: true,
    sortable: true,
    bodyStyle: "text-align: right;",
  },
  {
    header: "Текущ сут",
    field: "accumValueDay",
    visible: true,
    sortable: true,
    bodyStyle: "text-align: right;",
  },
  {
    header: "Ед изм",
    field: "unitShortName",
    visible: true,
    sortable: true,
  },
  {
    header: "Мгнов дебит",
    field: "rateT",
    visible: false,
    sortable: true,
    bodyStyle: "text-align: right;",
  },
  {
    header: "Мгнов дебит, м³",
    field: "rateM3",
    visible: true,
    sortable: true,
    bodyStyle: "text-align: right;",
  },
  {
    header: "Qреж, м³/сут",
    field: "rateM3Program",
    visible: true,
    sortable: true,
    bodyStyle: "text-align: right;",
  },
  {
    header: "Qсут, м³/сут",
    field: "rateM3Sum",
    visible: true,
    sortable: true,
    bodyStyle: "text-align: right;",
  },
  {
    header: "Откл от реж",
    field: "rateM3Departure",
    visible: true,
    sortable: true,
    bodyStyle: "text-align: right;",
  },
  {
    header: "Уд вес жид",
    field: "liquidDensity",
    visible: false,
    sortable: true,
    bodyStyle: "text-align: right;",
  },
  {
    header: "Свойства",
    field: "option",
    visible: false,
    sortable: true,
  },
  {
    header: "Рлин, атм(БГ)",
    field: "pressureLinearBMS",
    visible: true,
    sortable: true,
    bodyStyle: "text-align: right;",
  },

  {
    header: "Pлин, атм(скв)",
    field: "pressureLinearWell",
    visible: true,
    sortable: true,
    bodyStyle: "text-align: right;",
  },
  {
    header: "Питание",
    field: "power",
    visible: true,
    sortable: true,
    dataType: { type: "Checkbox" },
    bodyStyle: "text-align: center;",
  },
  {
    header: "Дверь",
    field: "doorSignalPropertyState",
    visible: true,
    sortable: true,
    dataType: { type: "Checkbox" },
    bodyStyle: "text-align: center;",
  },
  {
    header: "Обогр.",
    field: "heatingPropertyState",
    visible: true,
    sortable: true,
    dataType: { type: "Checkbox" },
    bodyStyle: "text-align: center;",
  },
  {
    header: "Работ.",
    field: "workingStatePropertyState",
    visible: true,
    sortable: true,
    dataType: { type: "Checkbox" },
    bodyStyle: "text-align: center;",
  },
  {
    header: "События",
    field: "activeEvent",
    tooltip: "activeEventsHint",
    bodyStyle: "white-space: nowrap",
    visible: true,
  },
  {
    header: "Дата обновления",
    field: "datePropertyLong",
    bodyStyle: "white-space: nowrap",
    visible: true,
  },
];

export const KOGS_COLUMNS = [
  {
    header: "Объект",
    field: "facilityName",
    sortable: true,
    visible: true,
    dataType: { type: "Link" },
    link: (row, vm) => vm.onClickFacilityLink(row),
    filterData: {
      options: "facilityNames",
      type: "MultiSelect",
      attrList: { filter: true, appendTo: "body", },
      mode: "in",
      "max-width": "80px",
    },
  },
  {
    header: "Состояние установки",
    field: "levelState",
    visible: true,
    sortable: true,
  },
  {
    header: "Описание аварии",
    field: "alarmUVSKOGS",
    visible: true,
    sortable: true,
  },
  {
    header: "Режим управления",
    field: "vacumMode",
    visible: true,
    sortable: true,
  },
  {
    header: "Загаз., %",
    field: "gasPercent",
    visible: true,
    sortable: true,
  },
  {
    header: "Моточасы",
    field: "machineHours",
    visible: true,
    sortable: true,
  },
  {
    header: "Уровень масла",
    field: "vacumState",
    visible: true,
    sortable: true,
  },
  {
    header: "Давление",
    field: "pressureLinear",
    visible: true,
  },
  {
    header: "Двигатель, ток",
    field: "amperage",
    visible: true,
  },
  {
    header: "Событие",
    field: "activeEvent",
    tooltip: "activeEventsHint",
    visible: true,
  },
  {
    header: "Дата события",
    field: "datePropertyLong",
    visible: true,
  },
];
export const KOGS_DETAILS_HEADER = [
  [
    { header: 'Объект', sortable: true, rowspan: 2,  field: "facilityName" },
    { header: 'Pmin, атм', rowspan: 2 },
    { header: 'Рвх, атм', rowspan: 2, },
    { header: 'Pmax, атм', rowspan: 2, },
    { header: 'Рвых, атм', rowspan: 2, },
    { header: 'Моточасы', colspan: 2, },
    { header: 'Состояние оборудования', colspan: 3, },
    { header: 'Состояние связи с объектом', rowspan: 2, },
    { header: 'Обогрев линий включен', rowspan: 2, },
    { header: 'Режим управления КОГС', rowspan: 2, },
  ],
  [
    { header: 'За все время', },
    { header: 'С нараст. итогом', },
    { header: 'В работе', },
    { header: 'В аварии', },
    { header: 'Обесточен', },
  ],
];
export const KOGS_DETAILS_COLUMNS = [
  {
    header: "Объект",
    field: "facilityName",
    visible: true,
    sortable: true,
    dataType: { type: "Link" },
    link: (row, vm) => vm.onClickFacilityLink(row),
    bodyStyle: "width: 210px",
    filterData: {
      options: "facilityNames",
      type: "MultiSelect",
      attrList: { filter: true },
      mode: "in",
      "max-width": "80px",
    },
  },
  {
    header: "Pmin, атм",
    field: "pressureSettingMin",
    visible: true,
    bodyStyle: "text-align: center; width: 80px",
  },
  {
    header: "Рвх, атм",
    field: "pressureLinearInput",
    visible: true,
    bodyStyle: "text-align: center; width: 80px",
    checkField: true,
    cellStyle: (data) => {
      if (data?.pressureLinearInput > 40) {
        return { backgroundColor: "#fe6d6c" };
      }
      if (data?.pressureLinearInput <= 40) {
        return { backgroundColor: "#c0dec0" };
      }
    },
  },
  {
    header: "Pmax, атм",
    field: "pressureSettingMax",
    visible: true,
    bodyStyle: "text-align: center; width: 80px",
  },
  {
    header: "Рвых, атм",
    field: "pressureLinearOutput",
    visible: true,
    bodyStyle: "text-align: center; width: 80px",
    cellStyle: (data) => {
      if (data?.pressureLinearOutput > data?.pressureSettingMax) {
        return { backgroundColor: "#fe6d6c" };
      }
      if (data?.pressureLinearInput <= 40) {
        return { backgroundColor: "#c0dec0" };
      }
    },
  },
  {
    header: "Моточасы",
    field: "machineHours",
    visible: true,
    bodyStyle: "text-align: center; width: 80px",
    cellStyle: (data) => {
      if (data?.machineHours <= 0) {
        return { backgroundColor: "#fe6d6c" };
      }
      if (data?.machineHours > 0) {
        return { backgroundColor: "#c0dec0" };
      }
    },
  },
  {
    header: "Моточасы с нараст. итогом",
    field: "machineHoursWithIncreasingTotal",
    visible: true,
    bodyStyle: "text-align: center; width: 80px",
  },
  {
    header: "В работе",
    field: "workState",
    visible: true,
    bodyStyle: "text-align: center; width: 80px",
    dataType: { type: "Checkbox" },
  },
  {
    header: "Авария",
    field: "accidentState",
    visible: true,
    bodyStyle: "text-align: center; width: 80px",
    color: "red",
    dataType: { type: "Checkbox" },
  },
  {
    header: "Обесточен",
    field: "deEnergizedState",
    visible: true,
    color: "red",
    bodyStyle: "text-align: center; width: 80px",
    dataType: { type: "Checkbox" },
  },

  {
    header: "Состояние связи с объектом",
    field: "connectionState",
    visible: true,
    bodyStyle: "text-align: center; width: 80px",
    dataType: { type: "Checkbox" },
  },
  {
    header: "Обогрев линий включен",
    field: "isHeatingOfLinesOn",
    visible: true,
    bodyStyle: "text-align: center; width: 80px",
    dataType: { type: "Checkbox" },
  },
  {
    header: "Режим управления КОГС",
    field: "controlMode",
    visible: true,
    bodyStyle: "",
  },
];

export const DGNU_COLUMNS = [
  {
    header: "Объект",
    field: "facilityName",
    sortable: true,
    visible: true,
    dataType: { type: "Link" },
    link: (row, vm) => vm.onClickFacilityLink(row),
    filterData: {
      options: "facilityNames",
      type: "MultiSelect",
      attrList: { filter: true },
      mode: "in",
      "max-width": "80px",
    },
  },
  {
    header: "Момент, Н*м",
    field: "reducerMomentum",
    visible: true,
    sortable: true,
  },
  {
    header: "Полож. плунж",
    field: "plungerCoord",
    visible: true,
    sortable: true,
  },
  {
    header: "Скорость. плунж",
    field: "plungVelocity",
    visible: true,
    sortable: true,
  },
  {
    header: "Активная мощность, кВт",
    field: "engineCurrent",
    visible: true,
    sortable: true,
  },
  {
    header: "P лин.",
    field: "press",
    visible: true,
    sortable: true,
  },
  {
    header: "Состояние",
    field: "value",
    visible: true,
    sortable: true,
  },
  {
    header: "Событие",
    field: "activeEvent",
    tooltip: "activeEventsHint",
    visible: true,
  },
  {
    header: "Дата события",
    field: "datePropertyLong",
    visible: true,
  },
];

export const MFN_COLUMNS = [
  {
    header: "Объект",
    field: "facilityName",
    sortable: true,
    visible: true,
    dataType: { type: "Link" },
    link: (row, vm) => vm.onClickFacilityLink(row),
    filterData: {
      options: "facilityNames",
      type: "MultiSelect",
      attrList: { filter: true },
      mode: "in",
      "max-width": "80px",
    },
  },
  {
    header: "Состояние насосов",
    field: "workingState",
    visible: true,
    sortable: true,
  },
  {
    header: "Давление Фл-1, атм",
    field: "pressureLinearFlangeFirst",
    visible: true,
    sortable: true,
  },
  {
    header: "Давление Фл-2, атм",
    field: "pressureLinearFlangeSecond",
    visible: true,
    sortable: true,
  },
  {
    header: "Давление дополн.",
    field: "pressureLinearFlangeAdditional",
    visible: true,
    sortable: true,
  },
  {
    header: "Частота, Гц",
    field: "frequency",
    visible: true,
    sortable: true,
  },
  {
    header: "Моточасы",
    field: "machineHours",
    visible: true,
    sortable: true,
  },
  {
    header: "Событие",
    field: "activeEvent",
    tooltip: "activeEventsHint",
    visible: true,
  },
  {
    header: "Дата события",
    field: "datePropertyLong",
    visible: true,
  },
];
